import React from 'react';
import logo from '../../assets/logo.png';

import styles from './Login.module.css';

interface FormLayoutProps {
  title: string;
  errorMessage: string;
  message: string;
  children: React.ReactNode;
}

const FormLayout: React.FC<FormLayoutProps> = ({
  title,
  errorMessage,
  message,
  children
}) => {
  return (
    <div className={styles['login-container']}>
      <div className={styles['login-bg']}></div>

      <div className={styles['login-content']}>

        <div className={styles['logo-container']}>
          <img src={logo} alt="Proprio Logo" />
        </div>

        <h1 className={styles['login-form-title']}>{title}</h1>

        <div className={styles['login-form-container']}>
          {errorMessage && <div className={styles['login-error-message']}>{errorMessage}</div>}
          {message && <div className={styles['login-success-message']}>{message}</div>}

          {children}
        </div>

      </div>
    </div>
  );
};

export default FormLayout;
